import { useCallback } from "react";
import styles from "./states.module.scss";

/**
 * Ref callback that keeps `--dg-refetch-w` on the bar at its grid viewport's
 * visible width, so the beam sweeps the columns in view rather than the
 * whole scroll width.
 */
const useVisibleWidthVar = () =>
    useCallback((bar: HTMLDivElement | null) => {
        const viewport = bar?.closest<HTMLElement>(
            "[role='grid'], [role='treegrid']",
        );
        if (!bar || !viewport) {
            return undefined;
        }
        const resizeObserver = new ResizeObserver(() => {
            bar.style.setProperty(
                "--dg-refetch-w",
                `${viewport.clientWidth}px`,
            );
        });
        resizeObserver.observe(viewport);
        return () => resizeObserver.disconnect();
    }, []);

/**
 * Shimmer beam travelling along the header's bottom divider while data
 * refetches. Rows stay mounted and dim through the root's `data-refetching`.
 */
export const RefetchBar = () => {
    const barRef = useVisibleWidthVar();
    return (
        <div
            ref={barRef}
            className={styles.refetchBar}
            aria-hidden
            data-testid="data-grid-refetch-bar"
        />
    );
};
